"use client";

import { Button } from "@/app/(components)/Basic/Button";
import FollowIcon from "@/assets/icons/follow.svg";
import UnfollowIcon from "@/assets/icons/unfollow.svg";
import useFollow from "@/shared/hooks/useFollow";

export interface Props {
  userId: string;
  isUserFollowing: boolean;
}

const ArtistFollowButton = ({ userId, isUserFollowing }: Props) => {
  const { isFollowing, toggleFollow } = useFollow({
    userId,
    isMeFollowing: isUserFollowing,
  });

  return (
    <Button
      startIcon={
        isFollowing ? (
          <UnfollowIcon className="w-5" />
        ) : (
          <FollowIcon className="w-5" />
        )
      }
      onClick={toggleFollow}
    >
      {isFollowing ? "Unfollow" : "Follow"}
    </Button>
  );
};

export default ArtistFollowButton;
